import { render, staticRenderFns } from "./CardProjectModule.vue?vue&type=template&id=4e8c4681&"
import script from "./CardProjectModule.vue?vue&type=script&lang=js&"
export * from "./CardProjectModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports